import {useEffect, useState, useRef} from 'react'
import { useParams } from 'react-router';
import { useNavigate } from 'react-router-dom';
import PageApp from '../../../Page';
import AddAcomulado from './AddAcomulado'
import { HomeOutlined, UnorderedListOutlined, ClockCircleFilled, ExclamationCircleFilled } from '@ant-design/icons';
import {Table, Empty, Modal, Divider, Button, message, Space, Typography} from 'antd';
import {getAllByConcept, drop} from '../../../../apis/ConceptoAcomuladoApi';
import {getById} from '../../../../apis/ConceptoApi';
import _ from 'lodash'

const { Title } = Typography;
const { confirm } = Modal;

const routes = [  {
        href: '',
        title: <>
        <HomeOutlined />
        <span>Inicio</span>
        </>,
    },
    {
        href: '',
        title: (
        <>
            <UnorderedListOutlined />
            <span>Catálogos</span>
        </>
        ),
    },
    {
        href: '../concepto',
        title: (
          <>
            <UnorderedListOutlined />
            <span>Conceptos</span>
          </>
        ),
    },
    {
        href: '',
        title: (
        <>
            <UnorderedListOutlined />
            <span>Acumulados</span>
        </>
        ),
    },
];

const Acomulados = () => {
    let navigate = useNavigate();
    const { conceptId } = useParams();
    const [concept, setConcept] = useState(null);
    const [items, setItems] = useState([]);
    const [openEdit, setOpenEdit] = useState(false);
    const [loading, setLoading] = useState(true);
    const [openNew, setOpenNew] = useState(false);
    
    const columns = [
      {
        title: 'Clave',
        dataIndex: 'concepto.clave',
        key: 'concepto.clave',
        render: (item, object)=> {
          return <Space>
            <span>{object.acomulado?.concepto?.clave}</span>
          </Space>
        }
      },
      {
        title: 'Descripcion',
        dataIndex: 'concepto.descripcion',
        key: 'concepto.descripcion',
        render: (item, object)=> {
          return <Space>
            <span>{object.acomulado?.concepto?.descripcion}</span>
          </Space>
        }
      },
      {
        title: '',
        dataIndex: 'actions',
        key: 'actions',
        render: (item, object)=> {
          return <Space>
            <Button type='primary' size='small' onClick={()=>{
              goToDetails(object);
            }}>Ver</Button>
            <Button type='primary' size='small' danger onClick={()=>{
                deleteConfirm(object);
            }}>Eliminar</Button>
          </Space>
        }
      }
    ];

    const deleteConfirm = async (item) => {
        confirm({
            title: '¿Confirmas en eliminar el concepto?',
            icon: <ExclamationCircleFilled />,
            content: 'No podrás recuperar su información',
            onOk: ()=>{deleteOk(item.id)},
            onCancel() {
                console.log('Cancel');
            },
        });
    }

    const deleteOk = async (id)=>{
        const response = await drop(id);
        if(response.ok){
            message.success('¡El concepto ha sido eliminadó!');
        }
        await refreshData();
    }

    const goToDetails = (object)=>{
      return navigate("../concepto_acomulado/" + object.acomulado_id);
    }

    const btnClick = ()=>{
      setOpenNew(true);
    }

    const onHandlerFinish = async (refresh) => {
      setOpenEdit(false);
      if(refresh){
        await refreshData();
      }
    }

    const refreshData = async ()=> {
      const response = await getAllByConcept(conceptId);
      if(response.ok){
        let items = response.payload;
        setItems(items);
      }

      setLoading(false);
    }

    const getConcept = async () => {
      const response = await getById(conceptId);
      if(response.ok){
        let item = response.payload;
        setConcept(item);
      }
    }

    const finishDetail = async () => {
      setOpenNew(false);
      await refreshData();
    }

    const effectRan = useRef(false);
    useEffect(() => {

      if (!effectRan.current) {
        (async () => {
          await refreshData();
          await getConcept();
        })();
      }
    
      return () => effectRan.current = true;
    }, []);

    
    return <PageApp routes={routes}
      title={<>
       {
        concept && <>({concept.clave}) {concept.descripcion}</>
       }
      </>} 
      cardTitle='Lista de tipos'
      extraCard={[
        <Button type="primary" onClick={btnClick}>
          Agregar Concepto Acumulado
        </Button>
      ]}
    >
      {
          loading ? (
            <p>Loading...</p>
          ) : <>
            {
              items.length == 0 ? <Empty />:
              <Table dataSource={items} columns={columns} />
            }
          </>
      }
      {
            openNew && 
            <div style={{marginBottom: 10}}>
              <AddAcomulado title="Agregar Acumulado" conceptoId={conceptId} finish={finishDetail} open={openNew}/>
            </div>
        }
    </PageApp>
}   

export default Acomulados;
